import { render, staticRenderFns } from "./ProcessDatasheetCard.vue?vue&type=template&id=18fcdd8a&scoped=true"
import script from "./ProcessDatasheetCard.vue?vue&type=script&lang=js"
export * from "./ProcessDatasheetCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fcdd8a",
  null
  
)

export default component.exports